/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Searchplaceholder2Inputs */

const en_coinvestments_nrl_searchplaceholder2 = /** @type {(inputs: Coinvestments_Nrl_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search data room documents`)
};

/**
* | output |
* | --- |
* | "Search data room documents" |
*
* @param {Coinvestments_Nrl_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_searchplaceholder2 = /** @type {((inputs?: Coinvestments_Nrl_Searchplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Searchplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_searchplaceholder2(inputs)
});
export { coinvestments_nrl_searchplaceholder2 as "coInvestments_nrl_searchPlaceholder" }